import React, { useMemo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { GlassSelect, GlassSelectOption } from '@/components/admin/redesign';

export interface DesktopDropdownOption {
  label: string;
  value: string;
}

interface DesktopDropdownSelectorProps {
  label: string;
  selectedValue?: string | number | null;
  options: DesktopDropdownOption[];
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  selectorStyle?: StyleProp<ViewStyle>;
}

/**
 * Single-value desktop dropdown rebuilt atop the theme-aware `GlassSelect`
 * primitive. Preserves the original prop API; the visual treatment now flows
 * from `admin.selector.*` tokens for free.
 */
export const DesktopDropdownSelector: React.FC<DesktopDropdownSelectorProps> = ({
  label,
  selectedValue,
  options,
  onChange,
  placeholder = 'Select',
  required,
  error,
  selectorStyle,
}) => {
  const glassOptions = useMemo<GlassSelectOption[]>(
    () => options.map((opt) => ({ label: opt.label, value: opt.value })),
    [options],
  );

  return (
    <GlassSelect
      label={label}
      selectedValue={selectedValue == null ? null : String(selectedValue)}
      options={glassOptions}
      onChange={(value) => onChange(String(value))}
      placeholder={placeholder}
      required={required}
      error={error}
      selectorStyle={selectorStyle}
    />
  );
};
